/**
 * Where Boona Direct lives, seen from either tab (boona repo: docs/codebase/inbox/README.md §9).
 *
 * The chat opens in a NAMED window so the journal reuses one chat tab instead of
 * opening a new one per click; each app also names its own window on boot, so the
 * other can find it after a reload.
 */

export const INBOX_WINDOW = "boona-inbox";
export const JOURNAL_WINDOW = "boona-journal";
export const INBOX_PATH = "/inbox/";

/** inbox-web, the central staff API + stream. */
export function inboxApiBase(): string {
  const configured = import.meta.env.VITE_INBOX_API_URL || "";
  return (configured || "https://inbox.boona.app").replace(/\/+$/, "");
}

export function inboxUrl(params: { client?: number; thread?: number } = {}): string {
  const q = new URLSearchParams();
  if (params.client) q.set("client", String(params.client));
  if (params.thread) q.set("thread", String(params.thread));
  const qs = q.toString();
  return `${INBOX_PATH}${qs ? `?${qs}` : ""}`;
}

/** Open (or re-use) the chat tab. Call it from the click itself — popup blockers. */
export function openInbox(params: { client?: number; thread?: number } = {}): Window | null {
  const win = window.open(inboxUrl(params), INBOX_WINDOW);
  try {
    win?.focus();
  } catch {
    // some browsers refuse focus() across tabs; the tab is open anyway
  }
  return win;
}

export function openJournal(): Window | null {
  const win = window.open("/", JOURNAL_WINDOW);
  try {
    win?.focus();
  } catch {
    // as above
  }
  return win;
}

/** The shard dashboard (the Modules page lives there). */
export function dashboardUrl(region: string | null, path: string): string {
  const base = region ? `https://dash-${region}.boona.app` : "https://dash.boona.app";
  return `${base}${path.startsWith("/") ? path : `/${path}`}`;
}
